import React,{Component} from 'react';
import './NewsPage.css';

import { API_URL, get_page_title } from '../../utils/config';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Article from '@acri-tools/react-tools/components/_articles/Article/Article';
import request from '@acri-tools/react-tools/utils/request';
import { Helmet } from 'react-helmet';

interface Props{
    match:any
}
interface State{
    loading?: boolean
    article?: any
}

class NewsPage extends Component<Props, State>{
    constructor(props:Props){
        super(props);
        this.state={}
    }
    componentDidMount(){
        this.fetch();
    }
    componentDidUpdate(prevProps:any){
        if(this.props.match.params.id !== prevProps.match.params.id){
            this.fetch();
        }
    }

    fetch = () =>{
        request(`${API_URL}/api/user-manager/v1/articles/${this.props.match.params.id}`)
        .then((res:any)=>{
            this.setState({ loading:false,  article: res.data });
        })
        .catch(e=>{
            this.setState({
                loading:false,
                // message: e.response && e.response.data && e.response.data.error  ? e.response.data.error : 'An error has occured.',
                // messageType: 'error'
            })
        })
    }

    render(){
        return (
        <Page 
            id="news-page"
            title="news page"
            topBar={{
                backTo: '/news'
            }}
            footer
        >
            <Helmet>
                <title>{ get_page_title(`Article - ${ this.state.article?.title ||  this.props.match.params.id}`) }</title>
                <meta 
                    name="description" 
                    content="DAMPS News article page"
                />
            </Helmet>
            <div className="page-content">
                {
                    this.state.article &&
                    <Article article={this.state.article}/>
                }
            </div>
        </Page>
        );
    }

};


// export default App;
export default (NewsPage);
